import axios from "axios";
export const api = axios.create({
  baseURL: " http://35.169.184.43:4000/", // Replace with your API base URL
});
